export const MapIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3281 1C6.8388 1 4 3.8388 4 7.32812C4 8.50705 4.32657 9.65758 4.94461 10.6557L9.96791 18.7507C10.0641 18.9058 10.2337 19 10.416 19C10.4174 19 10.4188 19 10.4202 19C10.6041 18.9986 10.7739 18.9014 10.8684 18.7436L15.7637 10.5702C16.3476 9.59317 16.6562 8.47207 16.6562 7.32812C16.6562 3.8388 13.8175 1 10.3281 1ZM14.8586 10.0288L10.408 17.4597L5.84103 10.1001C5.32659 9.26924 5.04766 8.31074 5.04766 7.32812C5.04766 4.42035 7.42035 2.04766 10.3281 2.04766C13.2359 2.04766 15.6051 4.42035 15.6051 7.32812C15.6051 8.2816 15.3445 9.21559 14.8586 10.0288Z"
        fill="#222530"
      />
      <path
        d="M10.3281 4.16406C8.58346 4.16406 7.16406 5.58346 7.16406 7.32812C7.16406 9.06164 8.56036 10.4922 10.3281 10.4922C12.1177 10.4922 13.4922 9.04259 13.4922 7.32812C13.4922 5.58346 12.0728 4.16406 10.3281 4.16406ZM10.3281 9.44453C9.15893 9.44453 8.21172 8.49415 8.21172 7.32812C8.21172 6.16502 9.16502 5.21172 10.3281 5.21172C11.4912 5.21172 12.441 6.16502 12.441 7.32812C12.441 8.47714 11.5158 9.44453 10.3281 9.44453Z"
        fill="#222530"
      />
    </svg>
  );
};
